import { render, staticRenderFns } from "./RadioItem.vue?vue&type=template&id=55bc5a0e&scoped=true&"
import script from "./RadioItem.vue?vue&type=script&lang=ts&"
export * from "./RadioItem.vue?vue&type=script&lang=ts&"
import style0 from "./RadioItem.vue?vue&type=style&index=0&id=55bc5a0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bc5a0e",
  null
  
)

export default component.exports